(function(window, document) {
  'use strict';
  
  function LazyLoad(options) {
    this.settings = Object.assign({
      threshold: 0,
      failure_limit: 0,
      event: "scroll",
      effect: "fadeIn",
      container: window,
      data_attribute: "original",
      skip_invisible: false,
      appear: null,
      load: null,
      placeholder: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAANSURBVBhXYzh8+PB/AAffA0nNPuCLAAAAAElFTkSuQmCC"
    }, options || {});
    
    this.elements = Array.from(document.querySelectorAll('.lazyload'));
    this.init();
  }
  
  LazyLoad.prototype = {
    init: function() {
      var self = this;
      this.elements.forEach(function(element) {
        element.loaded = false;
        if (element.tagName.toLowerCase() === 'img') {
          var src = element.getAttribute('src');
          if (!src || src === self.settings.placeholder) {
            element.setAttribute('src', self.settings.placeholder);
          }
        }
        self.addEventListener(element, 'appear', function() {
          if (!element.loaded) {
            if (self.settings.appear) {
              self.settings.appear.call(element, self.elements.length, self.settings);
            }
            var img = new Image();
            img.onload = function() {
              var original = element.getAttribute('data-' + self.settings.data_attribute);
              element.style.display = 'none';
              if (element.tagName.toLowerCase() === 'img') {
                element.setAttribute('src', original);
              } else {
                element.style.backgroundImage = "url('" + original + "')";
              }
              element.style.display = '';
              element.classList.add('lazyloaded'); // Add class for fade-in effect
              element.loaded = true;
              self.elements = self.elements.filter(function(el) {
                return !el.loaded;
              });
              if (self.settings.load) {
                self.settings.load.call(element, self.elements.length, self.settings);
              }
            };
            img.setAttribute('src', element.getAttribute('data-' + self.settings.data_attribute));
          }
        });
        if (self.settings.event.indexOf('scroll') === 0) {
          self.addEventListener(self.settings.container, self.settings.event, self.checkAppear.bind(self));
        }
        self.addEventListener(element, self.settings.event, function() {
          if (!element.loaded) {
            element.dispatchEvent(new Event('appear'));
          }
        });
      });
      
      this.addEventListener(window, 'resize', this.checkAppear.bind(this));
      if (/iphone|ipod|ipad.*os 5/gi.test(navigator.appVersion)) {
        this.addEventListener(window, 'pageshow', function(event) {
          if (event.persisted) {
            self.elements.forEach(function(element) {
              element.dispatchEvent(new Event('appear'));
            });
          }
        });
      }
      document.addEventListener('DOMContentLoaded', this.checkAppear.bind(this));
      window.addEventListener('load', this.checkAppear.bind(this)); // Ensures images load when the page is refreshed
    },
    
    checkAppear: function() {
      var self = this;
      var counter = 0;
      this.elements.forEach(function(element) {
        if ((!self.settings.skip_invisible || element.offsetParent !== null) && !self.belowTheFold(element) && !self.rightOfFold(element) && !self.aboveTheTop(element) && !self.leftOfBegin(element)) {
          element.dispatchEvent(new Event('appear'));
          counter = 0;
        } else if (++counter > self.settings.failure_limit) {
          return false;
        }
      });
    },
    
    addEventListener: function(element, event, handler) {
      element.addEventListener(event, handler);
    },
    
    belowTheFold: function(element) {
      var fold = (this.settings.container === window ? (window.innerHeight || document.documentElement.clientHeight) : this.settings.container.clientHeight) + this.getScrollTop();
      return fold <= this.getOffset(element).top - this.settings.threshold;
    },
    
    rightOfFold: function(element) {
      var fold = (this.settings.container === window ? (window.innerWidth || document.documentElement.clientWidth) : this.settings.container.clientWidth) + this.getScrollLeft();
      return fold <= this.getOffset(element).left - this.settings.threshold;
    },
    
    aboveTheTop: function(element) {
      var fold = this.settings.container === window ? this.getScrollTop() : this.getOffset(this.settings.container).top;
      return fold >= this.getOffset(element).top + this.settings.threshold + element.clientHeight;
    },
    
    leftOfBegin: function(element) {
      var fold = this.settings.container === window ? this.getScrollLeft() : this.getOffset(this.settings.container).left;
      return fold >= this.getOffset(element).left + this.settings.threshold + element.clientWidth;
    },
    
    getScrollTop: function() {
      return (this.settings.container === window ? window.pageYOffset : this.settings.container.scrollTop) || document.documentElement.scrollTop;
    },
    
    getScrollLeft: function() {
      return (this.settings.container === window ? window.pageXOffset : this.settings.container.scrollLeft) || document.documentElement.scrollLeft;
    },
    
    getOffset: function(element) {
      var rect = element.getBoundingClientRect();
      return {
        top: rect.top + this.getScrollTop(),
        left: rect.left + this.getScrollLeft()
      };
    }
  };
  
  window.LazyLoad = LazyLoad;
  
  document.addEventListener('DOMContentLoaded', function() {
    new LazyLoad();
  });
  
})(window, document);